import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { PersonPlusFill } from 'react-bootstrap-icons'
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import context from '../context/shared';
import { centerClient } from '../../../shared/clients';
import type { Client } from '../../../shared/generated';

const errorStr = "Необходимо заполнить поле ";
interface IAddClientFormProps{
    showTitle: string;
}
function AddClientForm(props: IAddClientFormProps) {
    const { refreshTree, setNewClientId, setShowRightClickPopup } = context;

    const { showTitle } = props;
    const [show, setShow] = useState(false);
    const {
        register, handleSubmit,
        formState: { errors },
        reset
    } = useForm();
    const handleAdd = (data) => {
        addClient(data);
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
        reset();
    }
    const handleClose = () => {
        setShow(false);
        setShowRightClickPopup(false);
    }
    const addClientSuccess = (newClient: Client) => {
        handleClose();
        refreshTree();
        setNewClientId(newClient.Id ?? null);
        toast.success("Клиент успешно добавлен.");
        reset();
    }
    function addClient(data) {
        centerClient.addClient(data)
            .then((res) => {
                const data = res.data;
                if (data)
                    addClientSuccess(data);
            })
            .catch(() => refreshTree());
    }
    return (
        <>
            <Button variant="transparent" onClick={handleShow} ><PersonPlusFill fill="var(--client)"/>{showTitle ? "Добавить клиента" : ""}</Button>
            <Modal show={show} onHide={handleClose} onEscapeKeyDown={handleClose }>
                <Modal.Header>
                    <Modal.Title>Добавить клиента</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Название</Form.Label>
                            <Form.Control type="input" {...register('name', { required: true })} placeholder="Название" />
                            {errors.name && <p>{errorStr + "Название"}.</p>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Логин</Form.Label>
                            <Form.Control type="input" {...register('login', { required: true })} placeholder="Логин" />
                            {errors.login && <p>{errorStr + "Логин"}.</p>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Пароль</Form.Label>
                            <Form.Control type="input" {...register('password', { required: true })} placeholder="Пароль" />
                            {errors.password && <p>{errorStr + "Пароль"}.</p>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Комментарий</Form.Label>
                            <Form.Control type="input" {...register('comment')} placeholder="Комментарий" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="custom" onClick={handleSubmit((data) => handleAdd(data))}>
                        Добавить
                    </Button>
                    <Button variant="custom" onClick={handleClose}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddClientForm;